"use client"
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, } from "@/components/ui/carousel"
import { useEffect, useRef } from "react";

const carouselFolder = "/images/carousel-accueil/";

const timeInSecond = 5;

export default function CarouselAcceuil() {
    const nextRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (nextRef.current) {
            const next = nextRef.current;
            const interval = setInterval(() => {
                next.click();
            }, timeInSecond * 1000);
            return () => clearInterval(interval);
        }
    }, []);


    return (<>
        <Carousel className="w-full" opts={{
            loop: true,
        }}>
            <CarouselPrevious className={"hidden"} />
            <CarouselContent>
                {[
                    42, 43, 36, 37, 38, 39, 40, 41, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
                    16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35,
                    36, 37, 38, 39, 40, 41, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                    18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35
                ].map((index) => (
                    <CarouselItem key={index}>
                        <img src={`${carouselFolder}${index}.jpg`} alt={"Image " + (index)} width={1080} height={500} className={"w-full"} />
                    </CarouselItem>
                ))}
            </CarouselContent>
            <CarouselNext className={"absolute opacity-0 w-0 h-0 z-0"} ref={nextRef} />
        </Carousel>
    </>);
}
